import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../supabaseClient';
import DashboardLayout from '../components/layout/Dashboardlayout.jsx';
import './Errorpages.css';
import { gsap } from 'gsap';
import Loader from '../components/layout/preloader';


const ErrorPages = () => {
  const [rows, setRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('edit');
  const [editRow, setEditRow] = useState(null);
  const [loading, setLoading] = useState(false);

  const [errorCode, setErrorCode] = useState('');
  const [titleEn, setTitleEn] = useState('');
  const [titleAr, setTitleAr] = useState('');
  const [btnEn, setBtnEn] = useState('');
  const [btnAr, setBtnAr] = useState('');
  const [asImg, setAsImg] = useState('');

  const pageRef = useRef(null);
  const headerRef = useRef(null);
  const cardsRef = useRef([]);
  const modalRef = useRef(null);

  const fetchRows = async () => {
    const { data } = await supabase.from('error_404').select('*').order('id');
    setRows(data || []);
  };

  useEffect(() => { fetchRows(); }, []);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

      tl.fromTo(
        headerRef.current,
        { opacity: 0, y: -22 },
        { opacity: 1, y: 0, duration: 0.6 }
      );
    }, pageRef);

    return () => ctx.revert();
  }, []);

  useEffect(() => {
    const valid = cardsRef.current.filter(Boolean);
    if (!valid.length) return;
    gsap.fromTo(
      valid,
      { opacity: 0, y: 28, scale: 0.97 },
      {
        opacity: 1, y: 0, scale: 1,
        duration: 0.5, stagger: 0.12,
        ease: 'power3.out', delay: 0.15,
      }
    );
  }, [rows]);

  useEffect(() => {
    if (showModal) {
      setTimeout(() => {
        if (!modalRef.current) return;
        gsap.fromTo(
          modalRef.current,
          { opacity: 0, scale: 0.94, y: 20 },
          { opacity: 1, scale: 1, y: 0, duration: 0.32, ease: 'power3.out' }
        );
      }, 10);
    }
  }, [showModal]);

  const animateModalOut = (callback) => {
    if (!modalRef.current) { callback(); return; }
    gsap.to(modalRef.current, {
      opacity: 0, scale: 0.94, y: 14,
      duration: 0.2, ease: 'power2.in',
      onComplete: callback,
    });
  };

  const resetForm = () => {
    setErrorCode(''); setTitleEn(''); setTitleAr('');
    setBtnEn(''); setBtnAr(''); setAsImg('');
  };

  const openAdd = () => {
    resetForm();
    setEditRow(null);
    setModalMode('add');
    setShowModal(true);
  };

  const openEdit = (row) => {
    setEditRow(row);
    setErrorCode(row.error_code || '');
    setTitleEn(row.title_en || '');
    setTitleAr(row.title_ar || '');
    setBtnEn(row.button_text_en || '');
    setBtnAr(row.button_text_ar || '');
    setAsImg(row['as-img'] || '');
    setModalMode('edit');
    setShowModal(true);
  };

  const closeModal = () => {
    animateModalOut(() => {
      setShowModal(false);
      setEditRow(null);
      resetForm();
    });
  };

  const handleSave = async () => {
    setLoading(true);
    const payload = {
      error_code: errorCode,
      title_en: titleEn,
      title_ar: titleAr,
      button_text_en: btnEn,
      button_text_ar: btnAr,
      'as-img': asImg,
    };
    if (modalMode === 'edit') {
      await supabase.from('error_404').update(payload).eq('id', editRow.id);
    } else {
      await supabase.from('error_404').insert([payload]);
    }
    await fetchRows();
    closeModal();
    setLoading(false);
  };

  const handleDelete = async (id) => {
    await supabase.from('error_404').delete().eq('id', id);
    await fetchRows();
  };

return (
    <>      <Loader />
    <DashboardLayout activePath="/dashboard/errors">
      <div className="ep-page" ref={pageRef}>

        <div className="ep-page-header" ref={headerRef}>
          <div>
            <h1 className="ep-page-title">ERROR PAGES MANAGER</h1>
            <p className="ep-page-subtitle">Customize error page</p>
          </div>
          <button className="ep-btn-add" onClick={openAdd}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Add Error Page
          </button>
        </div>

        <div className="ep-cards">
          {rows.map((row, index) => (
            <div className="ep-card" key={row.id} ref={(el) => (cardsRef.current[index] = el)}>

              <div className="ep-card-header">
                <span className="ep-card-tag">{row.error_code} ERROR PAGE</span>
                <div className="ep-actions">
                  <button className="ep-action-btn ep-edit-btn" onClick={() => openEdit(row)}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                    </svg>
                  </button>
                  <button className="ep-action-btn ep-delete-btn" onClick={() => handleDelete(row.id)}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="3 6 5 6 21 6"/>
                      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                      <path d="M10 11v6M14 11v6"/>
                      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
                    </svg>
                  </button>
                </div>
              </div>

              <div className="ep-card-image-row">
                {row['as-img'] ? (
                  <img src={row['as-img']} alt="error visual" className="ep-preview-img" />
                ) : (
                  <div className="ep-img-placeholder">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="3" width="18" height="18" rx="2"/>
                      <circle cx="8.5" cy="8.5" r="1.5"/>
                      <polyline points="21 15 16 10 5 21"/>
                    </svg>
                    <span>No image</span>
                  </div>
                )}
              </div>

              <div className="ep-card-fields">
                <div className="ep-field-pair">
                  <div className="ep-field">
                    <span className="ep-field-label">Title (EN)</span>
                    <span className="ep-field-value">{row.title_en || '—'}</span>
                  </div>
                  <div className="ep-field">
                    <span className="ep-field-label">Title (AR)</span>
                    <span className="ep-field-value ep-field-value--rtl">{row.title_ar || '—'}</span>
                  </div>
                </div>
                <div className="ep-field-pair">
                  <div className="ep-field">
                    <span className="ep-field-label">Button Text (EN)</span>
                    <span className="ep-field-value">{row.button_text_en || '—'}</span>
                  </div>
                  <div className="ep-field">
                    <span className="ep-field-label">Button Text (AR)</span>
                    <span className="ep-field-value ep-field-value--rtl">{row.button_text_ar || '—'}</span>
                  </div>
                </div>
                <div className="ep-field ep-field--full">
                  <span className="ep-field-label">Image URL</span>
                  <span className="ep-field-value ep-url-val">{row['as-img'] || '—'}</span>
                </div>
              </div>

            </div>
          ))}
        </div>

        {showModal && (
          <div className="ep-modal-overlay" onClick={closeModal}>
            <div className="ep-modal" ref={modalRef} onClick={(e) => e.stopPropagation()}>
              <div className="ep-modal-header">
                <h2 className="ep-modal-title">{modalMode === 'add' ? 'ADD ERROR PAGE' : 'EDIT ERROR PAGE'}</h2>
                <button className="ep-modal-close" onClick={closeModal}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"/>
                    <line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
              </div>
              <div className="ep-modal-body">
                <div className="ep-form-group">
                  <label>Error Code <span className="ep-required">*</span></label>
                  <input type="text" placeholder="e.g. 404" value={errorCode} onChange={(e) => setErrorCode(e.target.value)} />
                </div>
                <div className="ep-form-row">
                  <div className="ep-form-group">
                    <label>Title (EN) <span className="ep-required">*</span></label>
                    <input type="text" placeholder="e.g. NOT FOUND" value={titleEn} onChange={(e) => setTitleEn(e.target.value)} />
                  </div>
                  <div className="ep-form-group">
                    <label>Title (AR) <span className="ep-required">*</span></label>
                    <input className="ep-input--rtl" type="text" placeholder="الصفحة غير موجودة" value={titleAr} onChange={(e) => setTitleAr(e.target.value)} />
                  </div>
                </div>
                <div className="ep-form-row">
                  <div className="ep-form-group">
                    <label>Button Text (EN) <span className="ep-required">*</span></label>
                    <input type="text" placeholder="e.g. Go Back" value={btnEn} onChange={(e) => setBtnEn(e.target.value)} />
                  </div>
                  <div className="ep-form-group">
                    <label>Button Text (AR) <span className="ep-required">*</span></label>
                    <input className="ep-input--rtl" type="text" placeholder="العودة للخلف" value={btnAr} onChange={(e) => setBtnAr(e.target.value)} />
                  </div>
                </div>
                <div className="ep-form-group">
                  <label>Image URL</label>
                  <input type="text" placeholder="https://..." value={asImg} onChange={(e) => setAsImg(e.target.value)} />
                  {asImg && (
                    <div className="ep-img-preview-wrap">
                      <img src={asImg} alt="preview" className="ep-modal-img-preview" />
                    </div>
                  )}
                </div>
              </div>
              <div className="ep-modal-footer">
                <button className="ep-btn-cancel" onClick={closeModal}>Cancel</button>
                <button className="ep-btn-confirm" onClick={handleSave} disabled={loading}>
                  {loading ? 'Saving...' : modalMode === 'add' ? 'Add' : 'Save Changes'}
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </DashboardLayout></>
  );
};

export default ErrorPages;